import { render, staticRenderFns } from "./UpdateTeamNameForm.vue?vue&type=template&id=f478c5ce&"
import script from "./UpdateTeamNameForm.vue?vue&type=script&lang=js&"
export * from "./UpdateTeamNameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports